export class Common {
    static canPreviewFile(extension) {
        const supportedTypes = ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'xlx'];
        return supportedTypes.includes(extension.toLowerCase());
    }

    static isCreathlonProjec(groupType){
        return parseInt(groupType) === 7
    }
}